import styled from 'styled-components';

import variables from '../../../styles/variables';

// CARRIER
export const CarrierOfferWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 60px;
  padding: 10px 20px;
  margin: 0 0 15px 0;
  border-radius: 8px;
  border: 2px solid ${variables.colorRed};
  font-size: 14px;
  background: none;
  cursor: pointer;
`;

export const CollapsedContainer = styled.div`
  display: grid;
  position: relative;
  width: 100%;
  grid-template-columns: 0.5fr 0.5fr 1fr 1fr 1fr;
  grid-template-areas: 'radio logo price plan promo';
  grid-gap: 6px;
  align-items: center;
  justify-items: center;
  margin: 0;
  font-size: 12px;
  @media screen and (max-width: 500px) {
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      'radio logo .'
      'price promo plan';
  }
`;

export const CarrierLogoWrapper = styled.div`
  height: 40px;
  width: auto;
  img {
    width: auto;
    height: 100%;
  }
  @media screen and (max-width: 500px) {
    grid-area: logo;
  }
`;
export const MonthlyPrice = styled.div`
  text-align: center;
  grid-area: plan;
`;

export const Price = styled.span`
  font-weight: 600;
  font-size: 18px;
  @media screen and (max-width: 500px) {
    font-size: 14px;
  }
`;

export const UpFrontPrice = styled.div`
  text-align: center;
  grid-area: price;
`;

export const DetailLabel = styled.p`
  font-size: 10px;
  font-weight: 300;
  margin: 3px 0 0 0;
  @media screen and (max-width: 500px) {
    font-size: 12px;
    margin: 0;
  }
`;

export const PromoWrapper = styled.div`
  grid-area: promo;
  text-align: center;
  margin-right: 20px;
  @media screen and (max-width: 500px) {
    margin-right: 0;
  }
  .PhoneListTarget p span {
    @media screen and (max-width: 500px) {
      font-size: 14px;
    }

    @media screen and (max-width: 380px) {
      font-size: 12px;
      margin-bottom: 0.05rem;
    }
  }
`;

export const NoPromo = styled.p`
  grid-area: promo;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
  color: ${variables.colorGreyDark};
  @media screen and (max-width: 500px) {
    font-size: 12px;
  }
`;
